import BaseTransformer from "./base.transformer"

export const baseUri = "/api/users"
class TranslationsTransformer extends BaseTransformer {
  static fetch(translations) {
    const locale = {}
    translations.forEach((translation) => {
      Object.keys(translation).forEach((key) => {
        if (key !== "placeholder" && key !== "@id" && key !== "@type") {
          if (!locale[key]) {
            locale[key] = {}
          }
          locale[key][translation.placeholder] = translation[key]
        }
      })
    })

    return locale
  }
}

export default TranslationsTransformer
